



















































































import { Component, Vue } from "vue-property-decorator";
import Privacy from "./finder/Privacy.vue";
import Parent from "./finder/Parent.vue";
import Children from "./finder/Children.vue";
import HousingSituation from "./finder/Habitat.vue";
import Insurance from "./finder/Insurance.vue";
import LifeSituation from "./finder/LifeSituation.vue";
import Working from "./finder/Working.vue";
import Income from "./finder/Income.vue";
import Aside from "../components/Aside.vue";
import InformationField from "../components/InformationField.vue";
import { FinderStatus } from "@/shared/status";
import { Page } from "@/shared/page";
import { OverlayScrollbarsComponent } from "overlayscrollbars-vue";

@Component({
  components: {
    Privacy,
    Parent,
    Children,
    HousingSituation,
    Insurance,
    LifeSituation,
    Working,
    Income,
    Aside,
    InformationField,
    OverlayScrollbarsComponent,
  },
})
export default class Finder extends Vue {
  isValid = false;
  value?: FinderStatus;
  pages: Page[] = [];
  openSidebar = false;
  public $store: any;
  constructor() {
    super();
    if (this.$route.query.answers) {
      this.value = FinderStatus.fromJson(
        JSON.parse(this.$route.query.answers + "")
      );
      this.$store.commit("initAnswers", this.value);
    } else {
      this.value = this.$store.getters.answers;
    }
    if (this.value) {
      const text0 = `Viele Programme arbeiten mit Grenzwerten. Je genauer die Zahlen sind,
          die du bei uns eingibst, desto passgenauer die Ergebnisse, die wir dir
          anzeigen. Hast du nur ungefähre Werte zur Hand, trage diese ein. Das
          gibt dir zumindest eine erste Orientierung.`;
      this.pages = [
        new Page("privacy", "Datenschutz", this.value.privacy, `info`),
        new Page("parent", "Elternteil", this.value.parent, `info`),
        new Page(
          "children",
          "Kinder",
          this.value.children,
          `In vielen Programmen richtet sich die Förderung nach der Anzahl oder dem Alter der Kinder. Einige Programme gelten nur für Schwangere.`
        ),
        new Page(
          "lifeSituation",
          "Lebenssituation",
          this.value.lifeSituation,
          text0
        ),
        new Page(
          "housingSituation",
          "Wohnsituation",
          this.value.housingSituation,
          text0
        ),
        new Page("insurance", "Versicherung", this.value.insurance),
        new Page("working", "Beschäftigung", this.value.working),
        new Page("income", "Einkommen", this.value.income, text0),
      ];
    }
  }
  index = 0;
  setIndex(index: number) {
    this.index = index;
  }
  updateIsValid() {
    this.isValid = this.pages[this.index].status.isValid;
  }
  onChange(change: { key: string; value: any }) {
    this.pages[this.index].status = change.value;
    this.updateIsValid();
  }
  get currentIsValid(): boolean {
    return this.pages[this.index].status.isValid;
  }
  next() {
    if (this.value) this.value.updateValidity();
    if (this.isValid) {
      if (this.index < this.pages.length - 1) {
        this.index++;
        if (document.getElementById("main-content")) {
          let a: any = document.getElementById("main-content");
          a.scrollTop = 0;
        }
      } else {
        if (this.value?.isValid) {
          this.$store.commit("initAnswers", this.value);
          this.$router.push("results");
        }
      }
    }
    this.updateIsValid();
  }
  prev() {
    if (this.index > 0) {
      this.index--;
      if (document.getElementById("main-content")) {
        let a: any = document.getElementById("main-content");
        a.scrollTop = 0;
      }
    }
    this.updateIsValid();
  }
}
